module.exports = __webpack_public_path__ + "static/media/SeeingSound_04.1e9493e6.JPG";